module.exports = __webpack_public_path__ + "static/00021.0d6d553a.jpg";